import { NavbarV2 } from "@/components/landing-v2/NavbarV2";
import { Footer } from "@/components/landing/Footer";
import type { ReactNode } from "react";

export function LegalLayout({ title, lastUpdated, children }: { title: string; lastUpdated: string; children: ReactNode }) {
  return (
    <div className="bg-background min-h-screen">
      <NavbarV2 />
      <main className="pt-32 pb-24 sm:pt-40">
        <article className="mx-auto max-w-3xl px-6">
          <h1 className="font-display text-foreground text-3xl font-normal tracking-tight sm:text-4xl">{title}</h1>
          <p className="text-muted-foreground mt-2 text-sm">Last updated: {lastUpdated}</p>
          <div className="mt-10 space-y-8 [&_h2]:text-foreground [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-12 [&_h2]:mb-4 [&_h3]:text-foreground [&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-8 [&_h3]:mb-3 [&_p]:text-muted-foreground [&_p]:text-sm [&_p]:leading-relaxed [&_p]:mb-4 [&_ul]:text-muted-foreground [&_ul]:text-sm [&_ul]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ol]:text-muted-foreground [&_ol]:text-sm [&_ol]:leading-relaxed [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-2 [&_a]:text-brand [&_a]:underline [&_a]:underline-offset-2">
            {children}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
